import React from "react";
import { Table, Button, Input, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

const OrdersЕxecutionTable = () => {
  const { ordersExecution, loading } = useSelector(
    (state) => state.ordersExecutionReducer
  );

  const getFilterProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder="По-голямо от"
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => {
            confirm();
          }}
          style={{ width: 195, marginBottom: 10, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => {
              confirm();
            }}
            icon={<SearchOutlined />}
            size="small"
          >
            Филтрирай
          </Button>
          <Button
            onClick={() => {
              clearFilters();
              confirm();
            }}
            size="small"
          >
            Изчисти
          </Button>
        </Space>
      </div>
    ),
    onFilter: (value, record) => record[dataIndex] >= parseInt(value),
  });

  const columns = [
    {
      title: "Артикул",
      dataIndex: "itemName",
      rowKey: "itemName",
      sorter: (a, b) => a.itemName.localeCompare(b.itemName),
      key: "itemName",
      render: (text) => (
        <span className="orders-execution-table-text">{text ? text : "-"}</span>
      ),
    },
    {
      title: "Станция",
      dataIndex: "station",
      rowKey: "station",
      sorter: (a, b) => a.station.localeCompare(b.station),
      align: "center",
      key: "station",
      render: (text) => (
        <span className="orders-execution-table-text">{text ? text : "-"}</span>
      ),
    },
    {
      title: "К-во",
      dataIndex: "quantity",
      rowKey: "quantity",
      sorter: (a, b) => a.quantity - b.quantity,
      align: "center",
      key: "quantity",
      render: (text) => (
        <span className="orders-execution-table-text">{text}</span>
      ),
    },
    {
      title: "Сметка",
      dataIndex: "billId",
      rowKey: "billId",
      sorter: (a, b) => a.billId - b.billId,
      align: "center",
      key: "billId",
      render: (text) => (
        <span className="orders-execution-table-text">{text}</span>
      ),
    },
    {
      title: "Маса",
      dataIndex: "tableName",
      rowKey: "tableName",
      sorter: (a, b) => a.tableName - b.tableName,
      align: "center",
      key: "tableName",
      render: (text) => (
        <span className="orders-execution-table-text">{text}</span>
      ),
    },
    {
      title: "Час на поръчката",
      dataIndex: "orderedAt",
      rowKey: "orderedAt",
      sorter: (a, b) => dayjs(b.orderedAt) - dayjs(a.orderedAt),
      align: "center",
      key: "orderedAt",
      render: (date) => (
        <span className="orders-execution-table-text">
          {dayjs(date).format("DD.MM - HH:mm")}
        </span>
      ),
    },
    {
      title: "Започната след (мин)",
      dataIndex: "startedAfter",
      rowKey: "startedAfter",
      sorter: (a, b) => a.startedAfter - b.startedAfter,
      align: "center",
      key: "startedAfter",
      render: (text) => (
        <span className="orders-execution-table-text">{text ? text : "-"}</span>
      ),
    },
    {
      title: "Приготвена за (мин)",
      dataIndex: "preparedFor",
      rowKey: "preparedFor",
      sorter: (a, b) => a.preparedFor - b.preparedFor,
      align: "center",
      key: "preparedFor",
      render: (text) => (
        <span className="orders-execution-table-text">{text ? text : "-"}</span>
      ),
    },
    {
      title: "Сервирана след (мин)",
      dataIndex: "servedAfter",
      rowKey: "servedAfter",
      sorter: (a, b) => a.servedAfter - b.servedAfter,
      align: "center",
      key: "servedAfter",
      render: (text) => (
        <span className="orders-execution-table-text">{text ? text : "-"}</span>
      ),
    },
    {
      title: "Очаквано време за приготвяне (мин)",
      dataIndex: "expectedPrepareTime",
      rowKey: "expectedPrepareTime",
      sorter: (a, b) => a.expectedPrepareTime - b.expectedPrepareTime,
      align: "center",
      key: "expectedPrepareTime",
      render: (text) => (
        <span className="orders-execution-table-text">{text ? text : "-"}</span>
      ),
    },
    {
      title: "Забавяне приготвяне (мин)",
      dataIndex: "delay",
      rowKey: "delay",
      sorter: (a, b) => a.delay - b.delay,
      align: "center",
      key: "delay",
      render: (text) => (
        <span className="orders-execution-table-text">{text ? text : "-"}</span>
      ),
      ...getFilterProps("delay"),
    },
    {
      title: "Общо време за изпълнение (мин)",
      dataIndex: "overallPrepareTime",
      rowKey: "overallPrepareTime",
      sorter: (a, b) => a.overallPrepareTime - b.overallPrepareTime,
      align: "center",
      key: "overallPrepareTime",
      render: (text) => (
        <span className="orders-execution-table-text">{text ? text : "-"}</span>
      ),
    },
  ];

  return (
    <div className="orders-execution-table-container">
      <Table
        loading={loading}
        rowKey="orderID"
        showHeader
        dataSource={ordersExecution}
        columns={columns}
        pagination={false}
        className="orders-execution-table"
        rowClassName={(record) =>
          record.delay > 0 ? "orders-execution-table-row-red-background" : ""
        }
      />
    </div>
  );
};

export default OrdersЕxecutionTable;
